import React from 'react'
import './styles.scss'
import logo from 'assets/common/logo.png'
import phone from 'assets/common/phone.png'
import letter from 'assets/common/Letter.png'
import address from 'assets/common/Address.png'
import internet from 'assets/common/Internet.png'
import facebook from 'assets/common/Facebook.png'
import instagram from 'assets/common/Instagram.png'
import twitter from 'assets/common/Twitter.png'
import { Link } from 'react-router-dom'
import useSwitchPage from 'hooks/useSwitchPage'

function Footer() {
  const switchURL = useSwitchPage()
  return (
    <footer className="frame-footer">
      <div className="main-content">
        <div className="logo">
          <Link to={switchURL}>
            <img src={logo} alt="" />
          </Link>
          <p>Wear Your Passion!</p>
        </div>

        <div className="contact">
          <h5>CONTACT</h5>
          <div className="children-contact">
            <img src={phone} alt="" />
            <p>
              Support : <span>0326626065</span>
            </p>
          </div>
          <div className="children-contact-support">
            <img src={letter} alt="" />
            <p>admeloria1829@gmail.com</p>
          </div>
          <div className="children-contact">
            <img src={address} alt="" />
            <p>Bình Tân - thành phố Hồ Chí Minh</p>
          </div>
          <div className="children-contact">
            <img src={internet} alt="" />
            <p>Admeloria.com</p>
          </div>
        </div>

        <div className="policy">
          <h5>POLICY</h5>
          <Link to="/policy">
            <p>Privacy policy</p>
          </Link>
          <Link to="/questions">
            <p className="FAQ-policy">Frequently asked questions</p>
          </Link>
          <Link to="/warranty&Return">
            <p className="WRP-policy">Warranty & Return Policy</p>
          </Link>
        </div>
        <div className="followme">
          <h5>FOLLOW ME</h5>
          <div className="img_followme">
            <a href="https://www.facebook.com/TTUsportsclub" target="blank">
              <img src={facebook} alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/nuocduanhalam/" target="blank">
              <img src={instagram} alt="Instagram" />
            </a>
            <a href="https://www.twitter.com" target="blank">
              <img src={twitter} alt="Twitter" />
            </a>
          </div>
        </div>
      </div>

      <hr className="line-copyright" />
      <p className="text-copyright">Copyright © 2020 AD MELORIA Studio</p>
    </footer>
  )
}

export default Footer
